import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-small-badge',
  imports: [MatIconModule],
  templateUrl: './small-badge.component.html',
})
export class SmallBadgeComponent {
  @Input({ required: true }) text: string;
  @Input() icon: string;
}
